<nz-layout>
  <nz-content>
    <div nz-row [nzGutter]="10">
      <div nz-col nzSpan="24">
        <form
          nz-form
          nzLayout="vertical"
          [formGroup]="form"
          ngxsForm="appointment.employeeBooking"
          >
          <div nz-row [nzGutter]="[5, 0]">
            @if (!form.get('userId')?.value) {
              <div nz-col [nzSpan]="21">
                <beautyapp-select-search
                  formControlName="userId"
                  [data]="customers"
                  label="{{'calendar.form.user' | translate}}"
                  placeholder="{{'calendar.form.user' | translate}}"
                  (onSearch)="searchCustomer($event)"
                  prefixIcon="user"
                  valueMember="id"
                  displayMember="fullName"
                  required
                ></beautyapp-select-search>
              </div>
              <div nz-col [nzSpan]="3">
                <button
                  (click)="addNewuser()"
                  type="button"
                  nz-button
                  nzType="primary"
                  nzShape="circle"
                  style="margin-top: 40px"
                  >
                  <i nz-icon nzType="user-add" nzTheme="outline"></i>
                </button>
              </div>
            } @else {
              <div nz-col [nzSpan]="21">
                <nz-input-group [nzSuffix]="inputClearTpl">
                  <input
                    type="text"
                    prefixIcon="user"
                    nz-input
                    [ngModel]="selectedCustomer?.fullName"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="{{'calendar.form.user' | translate}}"
                    />
                </nz-input-group>
                <ng-template #inputClearTpl
                  >@if (selectedCustomer?.fullName) {
                  <i
                    nz-icon
                    class="ant-input-clear-icon"
                    nzTheme="fill"
                    nzType="close-circle"
                    (click)="form.get('userId')?.setValue(null)"
                    ></i
                    >
                  }</ng-template>
                </div>
                <div nz-col [nzSpan]="3">
                  <button
                    (click)="viewUser()"
                    type="button"
                    nz-button
                    nzType="primary"
                    nzShape="circle"
                    >
                    <i nz-icon nzType="eye" nzTheme="outline"></i>
                  </button>
                </div>
              }
              <div nz-col [nzSpan]="24">
                <beautyapp-datepicker
                  label="{{'calendar.form.date' | translate}}"
                  placeholder="{{'calendar.form.date' | translate}}"
                  formControlName="bookingDate"
                  required
                ></beautyapp-datepicker>
              </div>
              @if (!form.get('serviceId')?.value) {
                <div nz-col [nzSpan]="24">
                  <beautyapp-select-search
                    formControlName="serviceId"
                    [data]="services"
                    label="{{'calendar.form.procedure' | translate}}"
                    placeholder="{{'calendar.form.procedure' | translate}}"
                    (onSearch)="searchService($event)"
                    valueMember="id"
                    displayMember="name"
                    required
                  ></beautyapp-select-search>
                </div>
              } @else {
                <div nz-col [nzSpan]="24">
                  <nz-input-group [nzSuffix]="inputClearTplService">
                    <input
                      type="text"
                      nz-input
                      [ngModel]="selectedService?.name"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="{{'calendar.form.user' | translate}}"
                      />
                  </nz-input-group>
                  <ng-template #inputClearTplService
                    >@if (selectedService?.name) {
                    <i
                      nz-icon
                      class="ant-input-clear-icon"
                      nzTheme="fill"
                      nzType="close-circle"
                      (click)="form.get('serviceId')?.setValue(null)"
                      ></i
                      >
                    }</ng-template>
                  </div>
                }

                <div nz-col [nzSpan]="12">
                  <beautyapp-time-picker
                    label="{{'calendar.form.startingTime'}}"
                    placeholder="{{'calendar.form.startingTime'}}"
                    formControlName="startTime"
                    required
                  ></beautyapp-time-picker>
                </div>
                <div nz-col [nzSpan]="12">
                  <beautyapp-time-picker
                    label="{{'calendar.form.finishingTime'}}"
                    placeholder="{{'calendar.form.finishingTime'}}"
                    formControlName="endTime"
                    required
                  ></beautyapp-time-picker>
                </div>
                <div nz-col [nzSpan]="24">
                  <beautyapp-textarea
                    formControlName="description"
                    label="{{'calendar.form.comment'}}"
                    placeholder="{{'calendar.form.comment'}}"
                  ></beautyapp-textarea>
                </div>
                <div nz-col [nzSpan]="24">
                  <label nz-checkbox formControlName="sendNotification">
                    {{ 'calendar.form.sendNotification' | translate }}
                  </label>
                </div>
              </div>
            </form>
          </div>
        </div>
      </nz-content>
    </nz-layout>
    <div *nzModalFooter nz-row nzJustify="space-between">
      <div nz-col>
        <button nz-button nzType="default" (click)="modal.close()">{{'buttons.close' | translate}}</button>
        <button
          [disabled]="form.invalid || form.value.status === 2"
          nz-button
          nzType="primary"
          (click)="submit()"
          >
          {{'buttons.save' | translate}}
        </button>
      </div>
    </div>
